import { BadRequest, Forbidden, MethodNotAllowed, NotFound as BaseNotFound } from './base';
import { typeMap as errorTypeMap } from './type-map';

export class InvalidInputData extends BadRequest {
  constructor(payload) {
    super(errorTypeMap.common.invalidInputData, payload);
  }
}

export class DataMismatch extends MethodNotAllowed {
  constructor(payload) {
    super(errorTypeMap.common.dataMismatch, payload);
  }
}

export const NotFound = class extends BaseNotFound {
  constructor(payload) {
    super(errorTypeMap.common.notFound, payload);
  }
};

export class ActionForbidden extends Forbidden {
  constructor(payload) {
    super(errorTypeMap.common.actionForbidden, payload);
  }
}

export class CopyingToClipboardForbidden extends Forbidden {
  constructor(payload) {
    super(errorTypeMap.common.copyingToClipboardForbidden, payload);
  }
}
